import { useAppDispatch, useAppSelector } from "../redux/store/hooks"
import { selectProfessionalUser } from "../redux/ProfessionalAuthentication"
import Link from "../component/Link"
import {
    selectOnboardingIsRunningState,
    toggleOnBoardingState
} from "../redux/Onboarding"
import {
    NAVIGATION_VIEW,
    NavigationPaths
} from "../navigation/NavigationController"

function Footer() {
    const authenticated = useAppSelector(selectProfessionalUser)
    const dispatch = useAppDispatch()
    const onboardingState = useAppSelector(selectOnboardingIsRunningState)

    function startOnboarding() {
        dispatch(toggleOnBoardingState())
    }

    return (
        <>
            {!onboardingState && (
                <div
                    className={
                        "h-[40px] border-t mt-auto flex space-x-4 items-center justify-center"
                    }>
                    <Link
                        to={
                            authenticated !== undefined && authenticated ? NavigationPaths[NAVIGATION_VIEW.PROFESSIONAL_HELP_VIEW].path : NavigationPaths[NAVIGATION_VIEW.HELP_VIEW].path
                        }>
                        Hilfe
                    </Link>
                    {authenticated && (
                        <Link onClick={startOnboarding}>Onboarding</Link>
                    )}
                    <Link to={NavigationPaths[NAVIGATION_VIEW.LEGAL_VIEW].path}>
                        Impressum
                    </Link>
                </div>
            )}
        </>
    )
}

export default Footer
